
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import ScrollList from '@components/ScrollList'

export default {
components: {
Tab,
TabItem,
Group,
Cell,
XButton,
Search,
Badge,
ScrollList,
},
data() {
var scrollHeight = (window.innerHeight - 88) + '';
return {
scrollHeight: scrollHeight,
scrollTop: '88px',
loadurl: '',
isLoading: false,
tab: 0,
params: {},
list: []
}
},
computed: {
search() {
return this.$store.state.search
}
},
created() {
this.tab = this.$route.query.tab || 0
this.switchTab(this.tab);
},
activated() {
if (this.search.searching) this.resetList()
},
methods: {
handler(tab) {
this.switchTab(tab);
this.resetList();
},
switchTab(tab){
switch (tab) {
case 0:
this.params = {
pageSize: 20,
order_field: 'STATUS asc,DTR_TH asc',
order_type: '',
STATUS: '1'
}
this.loadurl = 'TH.ashx?action=Form_Query'
break
case 1:
this.params = {
pageSize: 20,
order_field: 'DT_PLAN',
order_type: '',
STATUS: '2,3,4,5,6,7,8,9'
}
this.loadurl = 'Trans.ashx?action=Form_Query'
break
case 2:
this.params = {
pageSize: 20,
order_field: 'DT_SIGN',
order_type: '',
STATUS: '10,11'
}
this.loadurl = 'Trans.ashx?action=Form_Query'
break
}
},
toSearch() {
this.$router.push({
path: './search'
})
},
onCancel() {
this.$store.commit('clearSearch')
if (this.search.searching) this.resetList()
},
refreshListData(list) {
this.list = list
let url = this.tab == 0 ? './th/' : './sh/'
this.list.forEach(item => {
item.url = url + 'order?ID=' + item.ID + '&WORKNO=' + item.WORKNO
})
},
resetList() {
let store_keywords = this.search.keywords;
for (var k in store_keywords) {
this.params[k] = store_keywords[k]
}
this.$refs.ScrollList.refresh()
}
}

}



// WEBPACK FOOTER //
// ./src/pages/sctsnew/Index.vue